function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "D3C97871-4039-4CEC-9D2B-3377D3A9D922");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with sketchtool.");

var _ref4 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  d: "M909,785 C905.1402,785 902,788.1402 902,792 C902,795.8591 905.1402,799 909,799 C912.8598,799 916,795.8591 916,792 C916,788.1402 912.8598,785 909,785 M912.9221,795.99 C911.9393,795.3887 910.5799,794.8 909,794.8 C907.4208,794.8 906.0607,795.3894 905.0772,795.99 C904.0433,794.9736 903.4,793.561 903.4,792 C903.4,788.9123 905.9123,786.4 909,786.4 C912.0877,786.4 914.6,788.9123 914.6,792 C914.6,793.561 913.9567,794.9736 912.9221,795.99 M906.3043,796.9063 C907.0526,796.5199 907.9759,796.2 909,796.2 C910.0248,796.2 910.9474,796.5199 911.6957,796.9056 C910.8949,797.3466 909.9765,797.6 909,797.6 C908.0228,797.6 907.1044,797.3466 906.3043,796.9063 M909,791.99986 C908.2279,791.99986 907.6,791.37196 907.6,790.59986 C907.6,789.82776 908.2279,789.19986 909,789.19986 C909.7721,789.19986 910.4,789.82776 910.4,790.59986 C910.4,791.37196 909.7721,791.99986 909,791.99986 M909,787.79986 C907.4558,787.79986 906.2,789.05566 906.2,790.59986 C906.2,792.14406 907.4558,793.39986 909,793.39986 C910.5442,793.39986 911.8,792.14406 911.8,790.59986 C911.8,789.05566 910.5442,787.79986 909,787.79986",
  id: "path-account-icon"
}));

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  id: "Design-systems",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Form-elements",
  transform: "translate(-902.000000, -785.000000)"
}, React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, React.createElement("use", {
  xlinkHref: "#path-account-icon"
})), React.createElement("use", {
  id: "account-icon",
  fill: "#42526E",
  xlinkHref: "#path-account-icon"
})));

var SvgAccountIcon = function SvgAccountIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAccountIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/account-icon.06504d3e.svg";
export { ForwardRef as ReactComponent };